import { DependencyList, EffectCallback, useEffect, useRef } from "react"

export const useUpdateEffect = (
  callback: EffectCallback,
  deps?: DependencyList | undefined,
) => {
  const first = useRef(true)

  useEffect(() => {
    if (first.current) {
      first.current = false
      return
    }

    return callback()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}
